import { render } from "./FloatCreate.vue?vue&type=template&id=e08de082&scoped=true"
import script from "./FloatCreate.vue?vue&type=script&lang=js"
export * from "./FloatCreate.vue?vue&type=script&lang=js"

import "./FloatCreate.vue?vue&type=style&index=0&id=e08de082&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e08de082"]])

export default __exports__